import { z } from 'zod';

// Wire names: the backend reads `mapping` and `options.display_unit` from this JSON text.
const shortlistQrMappingSchema = z
  .object({
    // A bad id is an unmapped slot, like the backend treats it.
    mapping: z
      .record(z.string(), z.number().int().positive().nullable().catch(null))
      .catch(() => ({})),
    options: z
      .looseObject({ display_unit: z.string().optional().catch(undefined) })
      .catch(() => ({}))
  })
  .catch(() => ({ mapping: {}, options: {} }));

export type ShortlistQrMapping = z.infer<typeof shortlistQrMappingSchema>;

/** The backend stores and returns this setting as JSON text. */
export function parseShortlistQrMapping(text: unknown): ShortlistQrMapping {
  try {
    return shortlistQrMappingSchema.parse(
      typeof text === 'string' && text ? JSON.parse(text) : undefined
    );
  } catch {
    // Unreadable text is an unmapped workspace, not an error.
    return shortlistQrMappingSchema.parse(undefined);
  }
}

export function serializeShortlistQrMapping(value: ShortlistQrMapping): string {
  return JSON.stringify(value);
}
